function checkRequired() {
    
          var response = "success";    
    
          $('.required').each(function() {
                 if(this.selectedIndex == 0) {
                       okayOrNot = false;
                       response="Please choose all required options before adding to cart.";
                       return false;
                 }
          });
          
         return response;
    }

function mgProductMenuOptionState(_this)
{
  
  if (mgProductHasOptions(_this.data.product))
      {
      return {
        buttonsSelector: '[data-product-menu-buttons-selectoptions]',
        buttons: [{
          selector: '[data-product-menu-button-share]',
          callback: function callback() {
            return _this.menu.changeState(_this.states.share);
          }
        }, {
          selector: '[data-product-menu-button-selectoptions]',
          callback: function callback() {
            return _this.menu.changeState(_this.states.atc);
          }
        }]
      }
      }
      else
      {
  return  {
        buttonsSelector: '[data-product-menu-buttons-atc]',
        buttons: [{
          selector: '[data-product-menu-button-share]',
          callback: function callback() {
            _this._clearFailure();
            _this.menu.changeState(_this.states.share);
          }
        }, {
          selector: '[data-product-menu-button-atc]',
          callback: function callback() {
            _this._clearFailure();
          }
        }]
  };
}
}

function mgProductHasOptions(p)
{
  
  if (arrayContains(p.tags,"options"))
    return true;
  if (arrayContains(p.tags,"envelope"))
    return true;
  if (arrayContains(p.tags,"ribbon"))
    return true;
  
  return false;
}

function arrayContains(arrhaystack, needle)
{
  
    for(i = 0; i < arrhaystack.length; i++)
    {
      if (arrhaystack[i].indexOf("options")>-1)
        return true;
    }
    return (arrhaystack.indexOf(needle) > -1);
}
function dynamicProductTitle(title)
{
  //var titleImage = $(".product-images img[alt|='flower']");
  var titleImage = $(".product-images img[alt*='" + title + "' i");
  var selectOption = $("#title option[value*='" + title + "' i]");
  $("#title").val(selectOption.val());
  if(titleImage.length)
    titleImage.parent().prependTo(".product-images");
  
  
  var titleText = $(".product-title").text();
  var newTitle=titleText.replace('Bridesmaid', selectOption.val());
  $(".product-title").text(newTitle); 
  
  $('nav.breadcrumb span:last').text(newTitle);
  
  var docTitle = document.title;
  document.title = docTitle.replace("Bridesmaid",selectOption.val());

  var docDesc = $('meta[name=description]').attr("content");
  var newDesc = textReplace(docDesc,"Bridesmaid",selectOption.val().toLowerCase());
  $('meta[name*=description]').remove();
  $('meta[property*=description]').remove();
  $('head').append( '<meta name="description" content="' +  newDesc + '">' );
  $('head').append( '<meta name="og:description" content="' +  newDesc + '">' );
  $('head').append( '<meta property="og:description" content="' +  newDesc + '">' );
  $('head').append( '<meta name="twitter:description" content="' +  newDesc + '">' );
  
}


var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
  return null;
};

var textReplace = function textReplace(text, searchMask, replaceMask) {
  var regEx = new RegExp(searchMask, "ig");
  var result = text.replace(regEx, replaceMask);
  return result;
  
}

var barHtml =`
    <section class="cart-menu-container cart-menu-highlight" data-cart-menu-container="" style="display: block; top: 774px;">
  <div class="cart-menu cart-menu-bundle">
    <div class="cart-menu-buttons cart-menu-buttons-slideout-closed" data-cart-menu-buttons-default="" style="">
    <div class="cart-menu-bundle-envelope-container">
<button class="cart-menu-button cart-menu-button-calculate-shipping cart-menu-button-bundle-envelope">
Envelope Color: 
</button>

<div class="option">
        <div class="option-values">
            <div class="option-select">
              <span class="option-select-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10">
  <path fill="currentColor" fill-rule="evenodd" d="M5.138 5.344l.004-.54L.005 9.457.567 10l5.138-4.652L6 5.08l-.29-.27L.57 0 0 .535"></path>
</svg></span>
            </div>
        </div>
      </div>
</div>

	<button class="cart-menu-button cart-menu-button-calculate-shipping cart-menu-button-bundle">
Bundle Price: <span class="old-price"></span><span class="new-price"></span>
      </button>

		<div id="savebundlecontainer">
		</div>

    </div>
  </div>
</section>
`;

var titles = [ "bridesmaid", "maid-honor","matron-honor", "flower-girl",  "junior-bridesmaid","house-party","personal-attendant","ring-bearer","honorary-bridesmaid","maid-honour","matron-honour","man-honor","bridesman" ];

var setBundleProduct = function setBundleProduct(path,images)
{
  titles.forEach(function(title) {
    
    var titleImage = $.grep(images, function (element, index) {
    // return whether myData.products.category == 'Toy'
    return element.src.indexOf(title) !== -1;
	});
    //console.log(titleImage);
  var productLink = $(".bundle-builder-app--bundle--product--show-more[href='/products/" + title + "']");
        if (productLink.length)
        {
          //console.log(titleImage[0].src);
          //console.log(productLink.closest("li").children(".bundle-builder-app--bundle--product-link").children("img"));
          productLink.closest("li").children(".bundle-builder-app--bundle--product-link").children("img").attr("src",titleImage[0].src);
        }
    
  });
  
}

function setBundlePriceSummary() {
	// do something after the div content has changed
    var originalPrice=$(".bundle-builder-app--bundle--original-price");
    var newPrice=$(".bundle-builder-app--bundle--total-price");
  
    if (originalPrice.length)
  {
    originalPrice.appendTo(".old-price");
    originalPrice.removeClass("bundle-builder-app--bundle--original-price");
  }
    if (newPrice.length)
  {
    newPrice.appendTo(".new-price");
    newPrice.removeClass("bundle-builder-app--bundle--total-price");
  }
}

function onBundlePageLoad()
{  
  $("#shopify-section-site-footer").hide();
  $(".bundle-builder-app--bundle--summary").appendTo("#savebundlecontainer");
  $(".bundle-builder-app--bundle--add-to-cart-button > span").addClass("cart-menu-button-checkout-text");
  $(".bundle-builder-app--bundle--add-to-cart-button").addClass("cart-menu-button cart-menu-button-checkout");
  $(".cart-menu-button-checkout").removeClass("bundle-builder-app--button").removeClass("bundle-builder-app--bundle--add-to-cart-button");
  $(".bundle-builder-app--bundle--total-price").appendTo(".new-price").removeClass("bundle-builder-app--bundle--total-price");
  
  $(".bundle-builder-app--bundle--contents-item:first").prependTo(".option-select");
  $(".bundle-builder-app--bundle--contents-item > div > select").addClass("option-select-input");
  //$(".bundle-builder-app--bundle--product:first").hide();
  
  
    var productData = JSON.parse($("#bundle-builder-app--bundle--data").html());
    
    productData.products.forEach(function(p) {
    if(p.image!=null)
    {
      var titleImage=false;
  titles.forEach(function(title) {
    if (p.image.src.indexOf(title)>0)
      titleImage=true;
  });
      
      if (!titleImage)
      {
    jQuery.getJSON('/products/' + p.handle, function(product) {
      setBundleProduct('/products/' + p.handle, product.product.images);
      
    } );
      }
      
    }
    });
  
  
  
  $(".bundle-builder-app--bundle--product-link > img").show();
}


var zGbl_DOM_ChangeTimer = null;

function HandleDOM_ChangeWithDelay (zEvent) {
    if (typeof zGbl_DOM_ChangeTimer == "number") {
        clearTimeout (zGbl_DOM_ChangeTimer);
        zGbl_DOM_ChangeTimer = '';
    }
    zGbl_DOM_ChangeTimer     = setTimeout (HandleDOM_Change, 333);
}

function HandleDOM_Change () {
      	setBundlePriceSummary();
  		$(".cart-menu-container").show();
  		onBundlePageLoad();
}

function loadBundle()
{
  
  
  //Will you by my cards bundle customization
  
  if ($(".bundle-builder-app--bundle--name").text().indexOf("Will You")>0)
  {
    
        $(".site-main").append(barHtml);
        if($('.bundle-builder-app--warning--bundle-in-cart').length)
          $(".cart-menu-container").hide();
        onBundlePageLoad();
    
    $('.bundle-builder-app--bundle--summary').observe('childlist subtree', function(record) {
      setBundlePriceSummary();
	})
    
          $('.bundle-builder-app--warning--bundle-in-cart').observe('childlist subtree', function(zEvent) {
    if (typeof zGbl_DOM_ChangeTimer == "number") {
        clearTimeout (zGbl_DOM_ChangeTimer);
        zGbl_DOM_ChangeTimer = '';
    }
    zGbl_DOM_ChangeTimer     = setTimeout (HandleDOM_Change, 333);
        
      });

/*
        $('.bundle-builder-app--bundle--summary').bind('DOMSubtreeModified', function() {
          setBundlePriceSummary();
      });

          $('.bundle-builder-app--warning--bundle-in-cart').bind('DOMSubtreeModified', function() {
          setBundlePriceSummary();
          $(".cart-menu-container").show();
          onBundlePageLoad();
      });
      */
    
    $(".bundle-builder-app--bundle--section--product-list").fadeIn(800);
    
  }
  
}

function loadCart()
{
  $(".item-properties > span:contains('1:')").each(function() {
    $(this).parent().addClass("item-properties-bundle-builder");
  });
  
}

//page load check title parameter
  if(getUrlParameter("title")!=null)
    dynamicProductTitle(getUrlParameter("title"));

	//page load check cart url
    if(window.location.href.indexOf("cart")>0)
    {
      loadCart();
    }

//jQuery Page Load
$( document ).ready(function() {
    
	//page load check bundle url
    if(window.location.href.indexOf("bundle")>0)
    {
      loadBundle();
    }
  
});

